var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-btn',{staticClass:"text-bold",attrs:{"dense":"","no-caps":"","unelevated":"","loading":_vm.loading,"type":"submit","color":"primary","padding":_vm.loading ? '0' : '0 12px'},scopedSlots:_vm._u([{key:"loading",fn:function(){return [_c('q-spinner-ios',{attrs:{"size":"xs"}})]},proxy:true}])},[_c('span',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }